<div class="content-wrapper">
  <div class="title">{{ 'member_dashboard_open_purchase_orders_title' | translate }}</div>
  @if (!purchaseOrders?.length) {
    <div>
      <p>{{ 'member_open_purchase_orders_empty' | translate }}</p>
    </div>
  }
  @for (purchaseOrder of purchaseOrders; track purchaseOrder) {
    <div class="purchase-order-wrapper">
      <div class="purchase-order-info">
        <div class="name">
          {{ 'member_dashboard_open_purchase_orders_purchase_order' | translate }} {{ purchaseOrder.orderNr }} -
          <span class="bold">
            {{ purchaseOrder.laboName }} -
            {{ purchaseOrder.analysisName }}
          </span>
        </div>
        <div class="amount">
          {{ purchaseOrder.sampleCount }} {{ (purchaseOrder.sampleCount == 1 ? 'member_dashboard_open_purchase_orders_sample' : 'member_dashboard_open_purchase_orders_samples') | translate }}
        </div>
      </div>
      <div class="buttons">
        <app-button
          classes="darkblue-default"
          text="{{ 'member_dashboard_open_purchase_orders_open' | translate }}"
          icon="eye-open"
          (emitClick)="onOpenClicked(purchaseOrder.orderId)"
        ></app-button>
      </div>
    </div>
  }
</div>
